import { render, staticRenderFns } from "./mastery.vue?vue&type=template&id=01a421e0&scoped=true"
import script from "./mastery.vue?vue&type=script&lang=js"
export * from "./mastery.vue?vue&type=script&lang=js"
import style0 from "./mastery.vue?vue&type=style&index=0&id=01a421e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a421e0",
  null
  
)

export default component.exports